/*
 *
 * Virtual Market
 * question-api - Servicios
 *
 * RYNDEM 2017
 *
 */

/* Core Imports */
import axios from 'axios';
import { API_URL } from './config';

/* Dev Tools */
import { DEBUG } from 'common-protocols';
const OBJECT_ID = 'question-api';

/*********************** Obtener todos los cuestionarios ***********************/
export function fetchQuestions(token) {
  DEBUG && console.log(OBJECT_ID + "@getQuestions: Obtener cuestionarios");

  let requestUrl = `${API_URL}/cuestionarios`;
  DEBUG && console.log(OBJECT_ID  + "@getQuestions: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "get",
    headers: {'X-AUTH-TOKEN': token},
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Obtener cuestionario por ID ***********************/
export function fetchQuestionsXID(token, idCuestionario) {
    DEBUG && console.log(OBJECT_ID + "@fetchQuestionsXID: Obtener cuestionarios");

    let requestUrl = `${API_URL}/cuestionarios/${idCuestionario}`;
    DEBUG && console.log(OBJECT_ID  + "@fetchQuestionsXID: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "get",
        headers: {'X-AUTH-TOKEN': token},
    }

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

/*********************** Determinar si el usuario es apto para la simulasión ***********************/
export function  userIsSuitable(token, term) {
  DEBUG && console.log(OBJECT_ID + "@userIsSuitable: Usuario apto ");

  let requestUrl = `${API_URL}/resultados`;
  DEBUG && console.log(OBJECT_ID  + "@userIsSuitable: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data : term,
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Enviar contrato por email ***********************/
export function  sendContract(token, term) {
  DEBUG && console.log(OBJECT_ID + "@sendContract: Enviar contrato");

  let requestUrl = `${API_URL}/enviarContrato`;
  DEBUG && console.log(OBJECT_ID  + "@sendContract: requestUrl --> " + requestUrl);

  let request = {
    url: requestUrl,
    method: "post",
    headers: {'X-AUTH-TOKEN': token},
    data : term,
  }

  return axios(request)
    .then(response=> ({ response }))
    .catch(error => ({ error }))
}

/*********************** Obtener Pais ***********************/
export function  getPaises() {
    DEBUG && console.log(OBJECT_ID + "@sendContract: Enviar contrato");

    let requestUrl = `${API_URL}/paises`;
    DEBUG && console.log(OBJECT_ID  + "@sendContract: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "get",
    }

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}



// WEBPACK FOOTER //
// ./src/services/question-api.js